import React, { useState } from "react";
import Form from "react-bootstrap/Form";
import * as Yup from 'yup';
import { Formik } from 'formik';
import Button from "react-bootstrap/Button";
import UserService from "../services/user.service";
import Container from "react-bootstrap/Container";
import Row from "react-bootstrap/Row";
import Col from "react-bootstrap/Col";
import { Link } from "react-router-dom";

const FORGOT_PASSWORD_MESSAGE = (
  <>
    If your email address is in the system, you will get an email to reset your password.
    If you do not receive an email in the next 20 minutes,{" "}
    <Link to="/contact">contact us</Link>.
  </>
);

const ForgotPassword = () => {
  let apiUrl = process.env.REACT_APP_LOCALHOST_URL;
  const [submitted, setSubmitted] = useState(false);

  const loginValidationSchema = Yup.object().shape({
    emailaddress: Yup.string()
      .required("*Email Address is required")
  });

  const handleLogin = async (values, actions) => {
    try {
      await UserService.forgotPassword(values.emailaddress);
    } catch (err) {
      // Still show the same message — do not reveal whether the email exists.
      console.error(err);
    }
    setSubmitted(true);
    actions.setSubmitting(false);
  };

  return (
    <Container>
      <Row>
        <Col sm={12} md={6}>
          <div style={{ padding: 30 }}>
            {process.env.REACT_APP_ENV === 'demo' &&
              <img src={apiUrl + "/img/site/Ignite_logo_full_black_demo.png"} width={"100%"} alt="Ignite Logo" />
            }
            {process.env.REACT_APP_ENV === 'production' &&
              <img src={apiUrl + "/img/site/Ignite_logo_full_black.png"} width={"100%"} alt="Ignite Logo" />
            }
          </div>
          <h1>Forgot Password</h1>
        </Col>
        <Col>
          <div className="card card-container">
            <img
              src="//ssl.gstatic.com/accounts/ui/avatar_2x.png"
              alt="profile-img"
              className="profile-img-card"
            />
            Enter your email address below. If an account exists with that email address, a password reset link will be sent to that address.

            <Formik
              initialValues={{ emailaddress: "" }}
              validationSchema={loginValidationSchema}
              onSubmit={handleLogin}
            >
              {({ values,
                errors,
                touched,
                handleChange,
                handleBlur,
                handleSubmit,
                isSubmitting }) => (
                <Form onSubmit={handleSubmit}>
                  <Form.Group className="mb-3" controlId="emailaddress">
                    <Form.Label>Email Address</Form.Label>
                    <Form.Control
                      name="emailaddress"
                      type="text"
                      placeholder="Email Address"
                      onChange={handleChange}
                      onBlur={handleBlur}
                      value={values.emailaddress}
                      className={touched.emailaddress && errors.emailaddress ? "error" : null}
                      disabled={submitted}
                    />
                    {touched.emailaddress && errors.emailaddress ? (
                      <div className="error-message">{errors.emailaddress}</div>
                    ) : null}
                  </Form.Group>
                  <Button variant="primary" onClick={handleSubmit} type="submit" disabled={isSubmitting || submitted}>
                    Send Link
                  </Button>
                  {submitted && (
                    <div className="form-group" style={{ marginTop: 15 }}>
                      <div className="alert alert-success" role="alert">
                        {FORGOT_PASSWORD_MESSAGE}
                      </div>
                    </div>
                  )}
                </Form>
              )}
            </Formik>
          </div>
        </Col>
      </Row>
    </Container>
  );
};

export default ForgotPassword;
